import { ColorRGB, ColorRGBnormalize, ColorReference } from '../../values/index.js'
import type * as Style from '../../index.js'
import * as Ruleset from '../../methods/set.js'

export const Reference = (color?: any): ColorReference => {
  if (!color) {
    return {
      id: null,
      alpha: null
    }
  }

  // Fixme: ColorReference accepting Colors is not type-safe concept.
  // Need to figure out how to deal with it another way.
  if (ColorRGB.isValid(color as any)) {
    return color
  }

  let id = color.id || null
  let alpha = color.alpha ?? null

  return {
    id,
    alpha
  }
}
export type Reference = ReturnType<typeof Reference>

// Checks if a color reference is valid, meaning respective color exists. If it is, that reference is returned, otherwise, a
// color reference with id being the internal color's id and alpha the current color's alpha is returned.
export const fixReference = (color: ColorReference, styles: Style.Rule[]): ColorReference => {
  if (color == null) return null

  // TODO: This looks a lot like ColorReference() normalize function that generates something different.
  if (!ColorReference.isValid(color)) return ColorReference({})

  if (!('id' in color)) return color

  // If it doesn't exist return a color reference with color id the internal color's id.
  if (!Ruleset.findByTypeAndId(styles, 'color', color.id)) {
    return { id: Ruleset.findBlankId(styles, 'color'), alpha: color.alpha }
  }

  return color
}
export const Props = (props: any = {}) => ColorRGBnormalize(props)
export const validate = ColorRGB.isValid
export type Props = ReturnType<typeof Props>
export const fix = (props: Props, styles: Style.Rule[]): Props => props
export const label = 'Color'
export const type = 'color'
export const forms = [
  { id: 'color', label: 'Colors', extractProperties: (props: Props) => props, validate: () => true }
]
export const category = 'basic'
